export default {
    okText: 'Ok',
    dismissText: 'Avbryt',
    extra: 'vänligen välj',
};
